"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var widgets_1 = require("@wix/wix-vod-api-site-based/dist/src/private/services/widgets/widgets");
var to_error_1 = require("../../parsers/to-error");
exports.privateWidgetsService = new widgets_1.PrivateWidgets();
exports.updateWidgetSettings = function (widgetId, settings) {
    return exports.privateWidgetsService
        .updateSettings(widgetId, object_1.keysToSnakeCase(settings))
        .then(function (response) { return object_1.keysToCamelCase(response.data); })
        .catch(to_error_1.toError);
};
exports.updateWidget = function (widgetId, widgetMetadata) {
    return exports.privateWidgetsService
        .create(widgetId, object_1.keysToSnakeCase(widgetMetadata))
        .then(function (response) { return object_1.keysToCamelCase(response.data); })
        .catch(to_error_1.toError);
};
//# sourceMappingURL=widgets.js.map